import { render, staticRenderFns } from "./privacyPolicies.vue?vue&type=template&id=439ef8bf&"
import script from "./privacyPolicies.vue?vue&type=script&lang=js&"
export * from "./privacyPolicies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports